import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const safeNumber = (v) => Number(v ?? 0);

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
  },

  header: {
    marginBottom: 16,
  },

  title: {
    fontSize: 16,
    fontWeight: "bold",
  },

  subTitle: {
    fontSize: 10,
    marginTop: 4,
    color: "#555",
  },

  metaRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
  },

  customerBox: {
    marginTop: 12,
    padding: 10,
    border: "1px solid #ddd",
    borderRadius: 4,
    backgroundColor: "#fafafa",
  },

  customerLabel: {
    fontSize: 9,
    color: "#777",
  },

  customerValue: {
    fontSize: 11,
    fontWeight: "bold",
    marginTop: 2,
  },

  tableHeader: {
    flexDirection: "row",
    borderBottom: "2px solid #000",
    paddingBottom: 6,
    marginTop: 16,
    marginBottom: 6,
    fontWeight: "bold",
  },

  row: {
    flexDirection: "row",
    borderBottom: "1px solid #e0e0e0",
    paddingVertical: 6,
  },

  colOrder: { width: "15%" },
  colProduct: { width: "35%" },
  colQty: { width: "15%", textAlign: "right" },
  colPrice: { width: "15%", textAlign: "right" },
  colTotal: { width: "20%", textAlign: "right" },

  footer: {
    marginTop: 18,
    alignItems: "flex-end",
  },

  grandTotalLabel: {
    fontSize: 10,
    color: "#555",
  },

  grandTotal: {
    fontSize: 12,
    fontWeight: "bold",
    marginTop: 4,
  },
});

export default function OrdersReportPdf({ orders = [], fromDate, toDate }) {
  const cleanOrders = orders.filter(
    (o) => o.quantity != null && o.price != null,
  );

  const customerName = cleanOrders[0]?.customerName || "—";

  const grandTotal = orders.reduce(
    (sum, o) => sum + safeNumber(o.quantity) * safeNumber(o.price),
    0,
  );

  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.title}>Korns Bakery</Text>
          <Text style={styles.subTitle}>Orders Report</Text>

          <View style={styles.metaRow}>
            <Text style={styles.subTitle}>
              Period: {fromDate} → {toDate}
            </Text>
            <Text style={styles.subTitle}>
              Generated: {new Date().toLocaleDateString()}
            </Text>
          </View>
        </View>

        {/* Customer Info */}
        <View style={styles.customerBox}>
          <Text style={styles.customerLabel}>Customer</Text>
          <Text style={styles.customerValue}>{customerName}</Text>
        </View>

        {/* Table Header */}
        <View style={styles.tableHeader}>
          <Text style={styles.colOrder}>Order #</Text>
          <Text style={styles.colProduct}>Product</Text>
          <Text style={styles.colQty}>Qty</Text>
          <Text style={styles.colPrice}>Price</Text>
          <Text style={styles.colTotal}>Total</Text>
        </View>

        {/* Rows */}
        {cleanOrders.map((o, i) => {
          const qty = safeNumber(o.quantity);
          const price = safeNumber(o.price);
          const lineTotal = qty * price;

          return (
            <View key={i} style={styles.row}>
              <Text style={styles.colOrder}>{o.orderId}</Text>
              <Text style={styles.colProduct}>{o.productName ?? "-"}</Text>
              <Text style={styles.colQty}>{qty}</Text>
              <Text style={styles.colPrice}>$ {price.toFixed(2)}</Text>
              <Text style={styles.colTotal}>$ {lineTotal.toFixed(2)}</Text>
            </View>
          );
        })}

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.grandTotalLabel}>Grand Total</Text>
          <Text style={styles.grandTotal}>USD {grandTotal.toFixed(2)}</Text>
        </View>
      </Page>
    </Document>
  );
}
